'use strict';

var module_instance;

var Module = class {
	
	constructor() {
		this.name = 'mvc-mywidget';
		this.current_version = "1.01.1.2020.12.05";
		
		this.global = null; // put by global on registration
		this.app = null;
		
		this.controllers = null;

		this.isready = false;
		this.isloading = false;
		
		this.clientapicontrollers = null; // API gateway

		this.client_wallet = null;

		this.currencies = null;

	}
	
	init() {
		console.log('module init called for ' + this.name);

		return true;
	}

	async initAsync() {
		console.log('module initAsync called for ' + this.name);

		try {
			// mvc module
			var Client_Wallet = require('@primusmoney/client_wallet');

			this.client_wallet = Client_Wallet.getObject();

			if (this.client_wallet.initialized === false)
				throw 'client_wallet should be initialized before calling mvc-mywidget.init';

			// get global object
			var clientglobal = this.client_wallet.getGlobalObject();
			// register this module
			this.global = clientglobal;

			// for debugging
			clientglobal.putGlobalStoredObject('global', clientglobal);

			// currencies module
			const Currencies = require('@primusmoney/currencies');
			//const Currencies = require('../../../../../nodemodules/@primusmoney/currencies');
			this.currencies = Currencies.getObject();
	
			await this.currencies.init();

			console.log('currency module is now initialized')
	
			this.isready = true;
	
			return true;
		}
		catch(e) {
			console.log('exception in mvc-mywidget.init: ' + e);
		}
	}

	// compulsory  module functions
	loadModule(parentscriptloader, callback) {
		console.log('loadModule called for module ' + this.name);
		
		if (this.isloading)
			return;
			
		this.isloading = true;

		var self = this;

		var modulescriptloader = parentscriptloader.getChildLoader('mvcmyquoteloader');

		modulescriptloader.load_scripts(function() { self.init(); if (callback) callback(null, self); });

		return modulescriptloader;	
	}
	
	isReady() {
		return this.isready;
	}

	hasLoadStarted() {
		return this.isloading;
	}

	// optional module functions
	registerHooks() {
		console.log('module registerHooks called for ' + this.name);
		
		var global = this.global;
		
		// initialization
	}
	
	postRegisterModule() {
		console.log('postRegisterModule called for ' + this.name);
		if (!this.isloading) {
			var global = this.global;
			var self = this;
			var rootscriptloader = global.getRootScriptLoader();
			
			this.loadModule(rootscriptloader, function() {
				if (self.registerHooks)
				self.registerHooks();
			});
		}
	}
	
 	_getClientAPI() {
		if (this.clientapicontrollers)
			return this.clientapicontrollers;
		
		var global = this.global;
		
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		
		this.clientapicontrollers = mvcclientwalletmodule._getClientAPI();
		
		return  this.clientapicontrollers;
	}

	getExecutionEnvironment() {
		var global = this.global;

		return global.getExecutionEnvironment();
	}

	setExecutionEnvironment(val) {
		var global = this.global;

		return global.setExecutionEnvironment(val);
	}

	getRegisteredClass(classname) {
		var global = this.global;

		return global.getModuleClass(this.name, classname);
	}

	getGlobalStoredObject(name) {
		var global = this.global;

		return global.getGlobalStoredObject(name);
	}

	//
	// hooks
	//
	
	//
	// mvc init
	//

	setClientModuleObject(clientmodule) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		mvcclientwalletmodule.setClientModuleObject(clientmodule);
	}

	//
	// API
	//

/* 	_getClientAPI() {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');

		return mvcclientwallet._getClientAPI()
	} */

	t(string) {
		// translation
		return this.global.t(string);
	}


	guid() {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.guid();
	}


	// events
	signalEvent(eventname, params) {
		var global = this.global;
		// TODO: replace for version >= 0.20.12
 /*		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.signalEvent(event);
 */
		if ((eventname in global.eventlisteners) === false)
		return;
	
		for (var i = 0; i < global.eventlisteners[eventname].length; i++) {
			var entry = global.eventlisteners[eventname][i];
			
			if (!entry)
				continue;
			
			var listener = entry.listener;
			
			listener(eventname, params);
		}

	}
	
	registerEventListener(eventname, listerneruuid, callback) {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.registerEventListener(eventname, listerneruuid, callback);
	}
	
	unregisterEventListener(eventname, listerneruuid) {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.unregisterEventListener(eventname, listerneruuid);
	}

	//
	// Crypto functions
	//

	async isValidAddress(sessionuuid, address) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.isValidAddress(sessionuuid, address);
	}
	
	async generatePrivateKey(sessionuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.generatePrivateKey(sessionuuid);
	}
	
	async isValidPrivateKey(sessionuuid, privatekey) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.isValidPrivateKey(sessionuuid, privatekey);
	}

	async areAddressesEqual(sessionuuid, address1, address2) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.areAddressesEqual(sessionuuid, address1, address2);
	}
	

	//
	// Session functions
	//


	async createBlankSession() {
		var global = this.global;

		var commonmodule = global.getModuleObject('common');

		var session = await commonmodule.createBlankSessionObject();

		if (!session)
			return Promise.reject('could not create session');

		var sessionuuid = session.getSessionUUID();

		return sessionuuid;
	}

	async getSession(sessionuuid) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid).catch(err => {});

		if (!session) {
			var commonmodule = global.getModuleObject('common');

			session = await commonmodule.createBlankSessionObject();
			session.setSessionUUID(sessionuuid);
		}

		return session.getSessionUUID();
	}
	


	// user
	async getUserInfo(sessionuuid) {
		if (!sessionuuid)
			return {};
		
		var _apicontrollers = this._getClientAPI();
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		return _apicontrollers.getUserInfo(session);
	}
	
 	async importSession(sessionuuid, schemeuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var commonmodule = global.getModuleObject('common');

		// look if session already exists
		var session = await _apicontrollers.getSessionObject(sessionuuid).catch(err => {});

		if (!session) {
			session = await commonmodule.createBlankSessionObject();
			session.setSessionUUID(sessionuuid);
		}

		if (!session)
			return Promise.reject('could not create session ' + sessionuuid);

		var walletmodule = global.getModuleObject('wallet');
		var Wallet = global.getModuleClass('wallet', 'Wallet');

		var scheme = await walletmodule.getSchemeFromUUID(session, schemeuuid);

		if (!scheme)
			throw new Error('could not find scheme');


		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');


		// set network config to the session
		//var network = scheme.getNetworkConfig();
		var network = mvcclientwallet._getSchemeNetworkConfig(scheme);
				
		await _apicontrollers.setSessionNetworkConfig(session, network);

		// save schemeuuid in session var (because missing 2021.11.13)
		session.setSessionVariable('schemeuuid', schemeuuid);


		let isanonymous = await mvcclientwallet._isAnonymousAsync(session);
		if (isanonymous)
			return Promise.reject('session needs to be authenticated');

		return sessionuuid;
	}

	async _getMonitoredSchemeSession(session, wallet, scheme) {
		var global = this.global;
		
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		return mvccurrencies._getMonitoredSchemeSession(session, wallet, scheme);
	}

	
	async setSessionScheme(sessionuuid, schemeuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);
	
		// set network config to the session
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		var network = mvcclientwalletmodule._getSchemeNetworkConfig(scheme);
				
		await _apicontrollers.setSessionNetworkConfig(session, network);

		// save schemeuuid in session var (because missing 2021.11.13)
		session.setSessionVariable('schemeuuid', schemeuuid);
	}

	async getSessionScheme(sessionuuid) {
		// note: clientsmodule does not store info on the schemeuuid
		// we do it at our level (and won't have it if session created by someone else)

		if (!sessionuuid)
		return Promise.reject('session uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var schemeuuid = session.getSessionVariable('schemeuuid');

		if (!schemeuuid)
			return Promise.reject('no scheme uuid save in session variables');

		return this.getScheme(sessionuuid, schemeuuid);
	}



	//
	// Storage
	//

	// Settings
	async readSettings(keys, defaultvalue) {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.readSettings(keys, defaultvalue);
	}
	
	async putSettings(keys, json) {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.putSettings(keys, json);
	}

	//
	// EthNode functions
	//



	//
	// Card encryption functions
	//

	// private key

	async getWalletDecryptingCard(sessionuuid, walletuuid, address) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getWalletDecryptingCard(sessionuuid, walletuuid, address);
	}

	async getCardPrivateKey(sessionuuid, walletuuid, carduuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getCardPrivateKey(sessionuuid, walletuuid, carduuid);
	}

	async setCardPrivateKey(sessionuuid, walletuuid, carduuid, privatekey) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.setCardPrivateKey(sessionuuid, walletuuid, carduuid, privatekey);
	}

	// symetric encryption

	async aesEncryptString(sessionuuid, walletuuid, carduuid, plaintext) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.aesEncryptString(sessionuuid, walletuuid, carduuid, plaintext);
	}

	async aesDecryptString(sessionuuid, walletuuid, carduuid, cyphertext) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.aesDecryptString(sessionuuid, walletuuid, carduuid, cyphertext);
	}

	// asymetric encryption
	async rsaEncryptString(sessionuuid, walletuuid, carduuid, recipientrsapublickey, plaintext) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.rsaEncryptString(sessionuuid, walletuuid, carduuid, recipientrsapublickey, plaintext);
	}
	
	async rsaDecryptString(sessionuuid, walletuuid, carduuid, senderrsapublickey, cyphertext) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.rsaDecryptString(sessionuuid, walletuuid, carduuid, senderrsapublickey, cyphertext);
	}

	async signString(sessionuuid, walletuuid, carduuid, plaintext) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.signString(sessionuuid, walletuuid, carduuid, plaintext);
	}

	async validateStringSignature(sessionuuid, walletuuid, address, plaintext, signature) {
		if (!plaintext)
			return Promise.reject('plain text is undefined');

		if (!signature)
			return Promise.reject('signature is undefined');

		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
		
		return _apicontrollers.validateStringSignature(session, address, plaintext, signature);
	}

	// TODO: should use mvcclientwalletmodule.validateStringCardSignature for version >= 0.30.11
	async validateStringCardSignature(sessionuuid, walletuuid, carduuid, plaintext, signature) {
		if (!plaintext)
			return Promise.reject('plain text is undefined');

		if (!signature)
			return Promise.reject('signature is undefined');

		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
		
		var card = await wallet.getCardFromUUID(carduuid);
		
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		var address = card.getAddress();

		return _apicontrollers.validateStringSignature(session, address, plaintext, signature);
	}


	//
	// Scheme functions
	//

	async getSchemeInfo(sessionuuid, schemeuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getSchemeInfo(sessionuuid, schemeuuid);
	}
	
	async getDefaultLocalSchemeInfo(sessionuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');

		return mvcclientwalletmodule.getDefaultLocalSchemeInfo(sessionuuid);
	}

	async setSchemeLabel(sessionuuid, schemeuuid, label) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.setSchemeLabel(sessionuuid, schemeuuid, label);
	}


	// TODO: replace with _apicontrollers.compareUrl for version >= 0.30.8
	_compareUrl(url1, url2) {
		var _url1 = (url1 && url1.endsWith('/') ? url1.substring(0, url1.length - 1 ) : url1);
		var _url2 = (url2 && url2.endsWith('/') ? url2.substring(0, url2.length - 1 ) : url2);

		if (_url1 && _url2 && (_url1 == _url2))
		return true;
		else
		return false;
	}

	async compareUrl(sessionuuid, url1, url2) {
		return this._compareUrl(url1, url2);
	}

	// remote schemes
	async importScheme(sessionuuid, config) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();


		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		if (!config || !config.uuid ||!config.authserver || !config.authserver.activate)
			return Promise.reject('importScheme is for remote schemes');

		var scheme = await _apicontrollers.createScheme(session, config);

		if (!scheme)
			return Promise.reject('could not create scheme ' + config.name);

		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		var schemeuuid = scheme.getSchemeUUID();

		return mvcclientwalletmodule.getSchemeInfo(sessionuuid, schemeuuid);
	}

	// local schemes
	async findLocalSchemeInfoFromWeb3Url(sessionuuid, web3url, options) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();


		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var scheme;

		// get list of local schemes
		var localschemes = await _apicontrollers.getLocalSchemeList(session, true);

		for (var i = 0; i < localschemes.length; i++) {
			var networkconfig = localschemes[i].getNetworkConfig();
			var ethnodeserverconfig = networkconfig.ethnodeserver;

			if (this._compareUrl(ethnodeserverconfig.web3_provider_url, web3url)) {
				// validate scheme matches options
				var bValid = true;
				var _keys = (options ? Object.keys(options) : []);

				for (var j = 0; j < _keys.length; j++) {
					if (options[_keys[j]] && (options[_keys[j]] != ethnodeserverconfig[_keys[j]]) ) {
						bValid = false;
						break;
					}
				}

				if (bValid) {
					scheme = localschemes[i];
					break;
				}
			}
		}

		if (!scheme)
			return Promise.reject('could not find scheme for ' + web3url);

		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		var schemeuuid = scheme.getSchemeUUID();

		return mvcclientwalletmodule.getSchemeInfo(sessionuuid, schemeuuid);
	}

	// TODO: replace with mvcclientwalletmodule.buildSchemeFromWeb3Url for version >= 0.30.8
	async buildSchemeFromWeb3Url(sessionuuid, walletuuid, web3url, options) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);


		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
	
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
			
		
		// clone scheme first
		var defaultlocalscheme = await _apicontrollers.getDefaultScheme(session, 0); // 0 = local
		
		var scheme = await defaultlocalscheme.cloneOnWeb3ProviderUrl(web3url)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not create scheme for ' + web3url);
		
		// change default ethnodeserver
		var ethnodeserverconfig = scheme.getEthNodeServerConfig();

		// set transaction info
		ethnodeserverconfig.default_gas_limit = (options.default_gas_limit ?  options.default_gas_limit : 21000);
		ethnodeserverconfig.default_gas_price = (options.default_gas_price ?  options.default_gas_price : 1000000000);
		ethnodeserverconfig.avg_transaction_fee = (options.avg_transaction_fee ?  options.avg_transaction_fee : 0.000021000);
		ethnodeserverconfig.transaction_units_min = (options.transaction_units_min ?  options.transaction_units_min : 2);

		// set service provider (e.g. top-up server)
		if (options.rest_server_url)
			ethnodeserverconfig.rest_server_url = options.rest_server_url;

		if (options.rest_server_api_path)
			ethnodeserverconfig.rest_server_api_path = options.rest_server_api_path;

		// set chainid and networkid (not done at this time in cloneOnWeb3ProviderUrl 2021.05.16)
		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);
		
		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
		var ethereumnodeaccessinstance = ethereumnodeaccessmodule.getEthereumNodeAccessInstance(childsession)

		if (options.chainid)
		ethnodeserverconfig.chainid = options.chainid;
		else
		ethnodeserverconfig.chainid = await ethereumnodeaccessinstance.web3_getChainId();

		if (options.networkid)
		ethnodeserverconfig.networkid = options.networkid;
		else
		ethnodeserverconfig.networkid = await ethereumnodeaccessinstance.web3_getNetworkId();

		// save scheme with modified parameters
		await scheme.save();

		// return scheme info
		var mvcclienwallet = global.getModuleObject('mvc-client-wallet');

		var schemeinfo = {uuid: scheme.getSchemeUUID()};

		mvcclienwallet._fillSchemeInfoFromScheme(schemeinfo, scheme);

		return schemeinfo;
	}

	async getSchemeERC20TokenInfo(sessionuuid, walletuuid, schemeuuid, tokenaddress) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);

		// get erc20 token contract
		var erc20token_contract = await _apicontrollers.importERC20Token(childsession, tokenaddress);

		var token = {address: tokenaddress};

		token.name = await erc20token_contract.getChainName();
		token.symbol = await erc20token_contract.getChainSymbol();
		token.decimals = await erc20token_contract.getChainDecimals();

		return token;
	}

	async getSchemeTransactionInfo(sessionuuid, schemeuuid, feelevel = null) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getSchemeTransactionInfo(sessionuuid, schemeuuid, feelevel);
	}

	async _getEthereumTransaction(session, txhash) {
		var global = this.global;

		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');

		const result = new Promise((resolve, reject) => { 
			ethereumnodeaccessmodule.readEthereumTransactionObject(session, txhash, (err, res) => {
				if (err) reject(err);
				else {
					var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
					var data = res.data;
					try {
						// can throw invalid UTF8 detected
						res.data_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(session, data);
					}
					catch(e) {}
				
					resolve(res);
				}
			})
			.then(res => {
				// fixing missing callback call when data == null
				// in EthereumNodeAccess.readEthereumTransactionObject
				if (res)
					return res;
				else
					throw new Error('no transaction found with hash ' + txhash);
			})
			.catch(err => {
				reject(err);
			});
		});
		
		return result;
	}

	async _readTransaction(session, txhash) {
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getTransaction(txhash,(err, res) => {
				if (err) reject(err); 
				else {
					var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
					var input = res.input;
					try {
						res.input_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(session, input);
					}
					catch(e) {}
				
					resolve(res);
				}
			})			
			.then(res => {
				// fixing missing callback calls when data == null
				// because of error read property of null in Transaction._createTransactionObject
				if (res)
					return res;
				else
					throw new Error('no transaction found with hash ' + txhash);
			})
			.catch(err => {
				reject(err);
			});
		});
		
		return result;
	}


	async getSchemeEthereumTransaction(sessionuuid, walletuuid, schemeuuid, txhash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);

		// TODO: uncomment for version >= 0.30.8
		//var ethereumtransaction = await _apicontrollers.getEthereumTransaction(childsession, txhash);
		var ethereumtransaction = await this._getEthereumTransaction(childsession, txhash);
		
		ethereumtransaction._ethtx = await this._readTransaction(childsession, txhash);
		//ethereumtransaction._ethtx = await apicontrollers.readTransaction(childsession, txhash);

		return ethereumtransaction;
	}

	async getSchemeEthereumTransactionReceipt(sessionuuid, walletuuid, schemeuuid, txhash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);

		return _apicontrollers.getEthereumTransactionReceipt(childsession, txhash);
	}



	async _getUnitsFromCredits(session, scheme, credits) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule._getUnitsFromCredits(session, scheme, credits);
	}


	// TODO: should use mvcclientwalletmodule._getRecommendedSchemeFeeLevel for version >= 0.30.8
	async _getRecommendedSchemeFeeLevel(session, wallet, scheme, tx_fee) {
		// standard fee level
		var	feelevel = {
			default_gas_limit_multiplier: 1,
			default_gas_price_multiplier: 1,
			avg_transaction_fee_multiplier: 1, 
			transaction_units_min_multiplier: 1
		};

		// get scheme transaction info
		var sessionuuid = session.getSessionUUID();
		var card_scheme = scheme;
		var tx_info = await this.getSchemeTransactionInfo(sessionuuid, card_scheme.uuid, feelevel);

		var gasLimit = tx_info.gasLimit;
		var gasPrice = tx_info.gasPrice;
		var avg_transaction_fee = tx_info.avg_transaction_fee;

		var gas_unit = (card_scheme && card_scheme.network && card_scheme.network.ethnodeserver && card_scheme.network.ethnodeserver.gas_unit ? parseInt(card_scheme.network.ethnodeserver.gas_unit) : 21000);
		var credit_cost_unit_ratio = (avg_transaction_fee * 1000000000000000000) / (gas_unit * gasPrice);

		// execution cost
		var units_exec_fee; 
		var credits_exec_fee;
		
		if (tx_fee.estimated_cost_credits) {
			credits_exec_fee = tx_fee.estimated_cost_credits;
			units_exec_fee = await this._getUnitsFromCredits(session, card_scheme, credits_exec_fee);
		}
		else {
			units_exec_fee = (tx_fee.estimated_cost_units ? Math.ceil(tx_fee.estimated_cost_units / credit_cost_unit_ratio) : 1);
			credits_exec_fee = await card_scheme.getTransactionCreditsAsync(units_exec_fee);
		}

		// max price
		var credits_max_fee = gasLimit * gasPrice;
		var units_max_fee =  await this._getUnitsFromCredits(session, card_scheme, credits_max_fee);

		if (units_exec_fee > units_max_fee)
			feelevel.default_gas_limit_multiplier = Math.ceil(units_exec_fee / units_max_fee);

		return feelevel;
	}

	// TODO: should use mvcclientwalletmodule.getRecommendedSchemeFeeLevel for version >= 0.30.8
	async getRecommendedSchemeFeeLevel(sessionuuid, walletuuid, schemeuuid, tx_fee) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);
		
	
		return this._getRecommendedSchemeFeeLevel(session, wallet, scheme, tx_fee);
	}

	// TODO: should use mvcclientwalletmodule.computeSchemeTransactionFee for version >= 0.30.8
	async computeSchemeTransactionFee(sessionuuid, walletuuid, schemeuuid, tx_fee, feelevel = null) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);
	
		// get scheme transaction info
		var card_scheme = scheme;
		var tx_info = await this.getSchemeTransactionInfo(sessionuuid, card_scheme.uuid, feelevel);

		var gasLimit = tx_info.gasLimit;
		var gasPrice = tx_info.gasPrice;
		var avg_transaction_fee = tx_info.avg_transaction_fee;

		var gas_unit = (card_scheme && card_scheme.network && card_scheme.network.ethnodeserver && card_scheme.network.ethnodeserver.gas_unit ? parseInt(card_scheme.network.ethnodeserver.gas_unit) : 21000);
		var credit_cost_unit_ratio = (avg_transaction_fee * gasPrice) / gas_unit;

		// execution cost
		var units_exec_fee; 
		var credits_exec_fee;
		
		if (tx_fee.estimated_cost_credits) {
			credits_exec_fee = tx_fee.estimated_cost_credits;
			units_exec_fee = await this._getUnitsFromCredits(session, card_scheme, credits_exec_fee);
		}
		else {
			units_exec_fee = (tx_fee.estimated_cost_units ? Math.ceil(tx_fee.estimated_cost_units / credit_cost_unit_ratio) : 1);
			credits_exec_fee = await card_scheme.getTransactionCreditsAsync(units_exec_fee);
		}

		// transferred value
		var units_transferred;
		var credits_transferred;

		if (tx_fee.transferred_credits) {
			credits_transferred = tx_fee.transferred_credits;
			units_transferred = await this._getUnitsFromCredits(session, card_scheme, credits_exec_fee);
		}
		else {
			units_transferred = tx_fee.transferred_credit_units;
			credits_transferred = await card_scheme.getTransactionCreditsAsync(units_transferred);
		}

		// max price
		var credits_max_fee = gasLimit * gasPrice;
		var units_max_fee =  await this._getUnitsFromCredits(session, card_scheme, credits_max_fee);

		// fill tx_fee
		tx_fee.tx_info = tx_info;

		tx_fee.estimated_fee = {};

		// estimated execution fee
		tx_fee.estimated_fee.execution_units = units_exec_fee; 
		tx_fee.estimated_fee.execution_credits = credits_exec_fee; 

		// estimated transaction total
		tx_fee.estimated_fee.total_credits = credits_exec_fee + credits_transferred; 
		tx_fee.estimated_fee.total_units = await this._getUnitsFromCredits(session, card_scheme, tx_fee.estimated_fee.total_credits); 

		// max fee
		tx_fee.estimated_fee.max_units = units_max_fee; 
		tx_fee.estimated_fee.max_credits = credits_max_fee; 

		// required balance
		if (tx_fee.estimated_fee.max_credits > tx_fee.estimated_fee.total_credits) {
			tx_fee.required_credits = tx_fee.estimated_fee.max_credits;
		}
		else {
			if (tx_fee.estimated_fee.max_credits >= tx_fee.estimated_fee.execution_credits)
				tx_fee.required_credits = tx_fee.estimated_fee.max_credits + credits_transferred; // because of "Insufficient funds for gas * price + value" web3 error
			else {
				tx_fee.required_credits = tx_fee.estimated_fee.total_credits; // won't go through because will reach gas limit
				tx_fee.limit_overdraft = true;
			}
		}
		
		tx_fee.required_units =  await this._getUnitsFromCredits(session, card_scheme, tx_fee.required_credits); 

		return tx_fee;
	}
	
	async _getEthAccountTransactionCredits(session, account) {
		var global = this.global;
		var ethnodemodule = global.getModuleObject('ethnode');
		
		var ethereumnodeaccess  = ethnodemodule.getEthereumNodeAccessInstance(session);
		var address = account.getAddress();

		var balance = await ethereumnodeaccess.web3_getBalance(address);

		return parseInt(balance);
	}

	// TODO: should use mvcclientwalletmodule.canCompleteSchemeTransaction for version >= 0.30.8
	async canCompleteSchemeTransaction(sessionuuid, walletuuid, schemeuuid, fromprivatekey, tx_fee, feelevel = null) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);
		
	
		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);
		
		// get account for privatekey
		var account = childsession.createBlankAccountObject();
		if (!account)
			return Promise.reject('could not create account object');

		account.setPrivateKey(fromprivatekey);

		if (account.isPrivateKeyValid() !== true)
			return Promise.reject('invalid private key');

		const balance_transactioncredits = await this._getEthAccountTransactionCredits(childsession, account);
		const balance_transactionunits = await scheme.getTransactionUnitsAsync(balance_transactioncredits);
	
		// get transaction fee
		var tx_fee = await this.computeSchemeTransactionFee(sessionuuid, walletuuid, schemeuuid, tx_fee, feelevel);

		// check estimated cost is not above max credits (corresponds to tx_fee.limit_overdraft == true)
		if (tx_fee.estimated_fee.execution_credits > tx_fee.estimated_fee.max_credits) {
			return false;
		}

		// check balance in units is above requirement
		if (balance_transactionunits < tx_fee.required_units) {
			return false;
		}

		// check
		var tx_info = tx_fee.tx_info;
		var scheme_units_threshold = tx_info.units_threshold;
		var scheme_credits_threshold = tx_info.credits_threshold;

		if (scheme_credits_threshold > balance_transactioncredits) {
			if (tx_fee.threshold_enforced === true) {
				tx_fee.required_units = scheme_credits_threshold;
				return false;
			}
			else {
				tx_fee.threshold_unmet = true;
			}
		}


		return true;
	}

	// TODO: should use mvcclientwalletmodule.transferSchemeTransactionUnits for version >= 0.30.8
	async transferSchemeTransactionUnits(sessionuuid, walletuuid, schemeuuid, fromprivatekey, toaddress, units, feelevel = null) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		// session on scheme	
		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);
	
		// get account for privatekey
		var fromaccount = childsession.createBlankAccountObject();
		if (!fromaccount)
			return Promise.reject('could not create account object');

		fromaccount.setPrivateKey(fromprivatekey);

		if (fromaccount.isPrivateKeyValid() !== true)
			return Promise.reject('invalid private key');

		// create transaction object
		var transactioninfo = await this.getSchemeTransactionInfo(sessionuuid, schemeuuid);
		var transaction = _apicontrollers.createEthereumTransaction(childsession, fromaccount);
		
		// parameters
		var ethnodemodule = global.getModuleObject('ethnode');

		var weiamount = ethnodemodule.getWeiFromEther(transactioninfo.avg_transaction_fee);
		var ethamount = await this._createDecimalAmount(childsession, weiamount, 18);
		ethamount.multiply(units);
		var valuestring = await ethamount.toFixedString();

		transaction.setToAddress(toaddress);
		transaction.setValue(valuestring);

		// fee
		var fee = await _apicontrollers.createSchemeFee(scheme, feelevel);

		transaction.setGas(fee.gaslimit);
		transaction.setGasPrice(fee.gasPrice);

		
		const txhash = await _apicontrollers.sendEthereumTransaction(childsession, transaction)
		.catch((err) => {
			console.log('error in transferTransactionUnits: ' + err);
		});

		if (!txhash)
			return Promise.reject('could not send ethereum transaction');

		return txhash;	
	}


	// TODO: should use mvcclientwalletmodule.createSchemeERC20Token for version >= 0.30.8
	async createSchemeERC20Token(sessionuuid, walletuuid, schemeuuid, fromprivatekey, erc20token, feelevel = null) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		// session on scheme	
		var childsession = await this._getMonitoredSchemeSession(session, wallet, scheme);

		// get account for privatekey
		var fromaccount = childsession.createBlankAccountObject();
		if (!fromaccount)
			return Promise.reject('could not create account object');

		fromaccount.setPrivateKey(fromprivatekey);

		if (fromaccount.isPrivateKeyValid() !== true)
			return Promise.reject('invalid private key');
	
		// create transaction object
		var transaction = _apicontrollers.createEthereumTransaction(childsession, fromaccount);

		// fee
		var fee = await _apicontrollers.createSchemeFee(scheme, feelevel);

		transaction.setGas(fee.gaslimit);
		transaction.setGasPrice(fee.gasPrice);
		

		// create contract object
		var ethnodemodule = global.getModuleObject('ethnode');
		var erc20tokenmodule = global.getModuleObject('erc20');
	
		var erc20tokencontrollers = erc20tokenmodule.getControllersObject();

		// unlock account
		var password;
		var unlocked =	await ethnodemodule.unlockAccount(childsession, fromaccount, password, 300)
		
		// create (local) erc20token for these values
		var data = [];
		
		data['name'] = erc20token.name;
		data['symbol'] = erc20token.symbol;
		data['decimals'] = erc20token.decimals;
		data['totalsupply'] = erc20token.totalsupply;

		var erc20token_contract = erc20tokencontrollers.createERC20TokenObject(childsession, data);
	
		// deploy
		var gasLimit = transaction.getGas();
		var gasPrice = transaction.getGasPrice();
		var contract_address = await erc20token_contract.deploy(fromaccount, gasLimit, gasPrice);

		// relock account
		var relocked = await ethnodemodule.lockAccount(childsession, fromaccount);

		var tokenaddress = contract_address;
		var tokenuuid = erc20token_contract.getUUID();

		var result = {uuid: tokenuuid, address: tokenaddress};

		return result;
	}

	//
	// Wallet functions
	//
	async getWalletList(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallets = await _apicontrollers.getWalletList(session, true);

		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');

		var arr = [];

		for (var i = 0; i < (wallets ? wallets.length : 0); i++) {
			var walletinfo = {};
			mvcclientwallet._fillWalletInfo(walletinfo, wallets[i]);
			arr.push(walletinfo);
		}
		
		return arr;
	}

	async isWalletLocked(sessionuuid, walletuuid) {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.isWalletLocked(sessionuuid, walletuuid);
	}

	async unlockWallet(sessionuuid, walletuuid, password) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		let unlocked = await wallet.unlock(password);

		return unlocked;
	}
	
	async getWalletInfo(sessionuuid, walletuuid) {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.getWalletInfo(sessionuuid, walletuuid);
	}

	async makeWallet(sessionuuid, authname, schemeuuid, password) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');

		return mvcclientwalletmodule.makeWallet(sessionuuid, authname, schemeuuid, password);
	}

	async makeWalletFromSession(sessionuuid, schemeuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.makeWalletFromSession(sessionuuid, schemeuuid);
	}

	async attachSessionToWallet(sessionuuid, walletuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.attachSessionToWallet(sessionuuid, walletuuid);
	}


	//
	// Card functions
	//
	async _getMonitoredCardSession(session, wallet, card) {
		var cardsession = card._getSession();

		return cardsession;
	}


	async createWalletCard(sessionuuid, walletuuid, schemeuuid, privatekey) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);
	

		const card = await _apicontrollers.createWalletCard(session, wallet, scheme, privatekey)
		.catch(err => {
			console.log('error in createWalletCard: ' + err);
		});

		if (!card)
			return Promise.reject('could not create card');

		if (card.isLocked()) {
			await card.unlock();
		}

		const bSave = await card.save();

		if (!bSave)
			return Promise.reject('could not save card');

		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		var cardinfo = {};

		mvcclientwalletmodule._fillCardInfo(cardinfo, card);
		
		return cardinfo;	
	}

	async getWalletCard(sessionuuid, walletuuid, carduuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var card = await wallet.getCardFromUUID(carduuid);

		if (!card)
			return Promise.reject('could not find card ' + carduuid);
	

		if (card.isLocked()) {
			await card.unlock();
		}

		const bSave = await card.save();

		if (!bSave)
			return Promise.reject('could not save card');

		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		var cardinfo = {};

		mvcclientwalletmodule._fillCardInfo(cardinfo, card);
			
		return cardinfo;	
	}

	// copy of mvc-myquote
	async getCurrencyCardWithAddress(sessionuuid, walletuuid, currencyuuid, address) {
		var global = this.global;
		
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		return mvccurrencies.getCurrencyCardWithAddress(sessionuuid, walletuuid, currencyuuid, address);
	}


	async createReadOnlyCurrencyCard(sessionuuid, walletuuid, currencyuuid, address) {
		var global = this.global;
		
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		return mvccurrencies.createReadOnlyCurrencyCard(sessionuuid, walletuuid, currencyuuid, address);
	}

	async getCardInfoFromAddressOnScheme(sessionuuid, walletuuid, schemeuuid, address) { 
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getCardInfoFromAddressOnScheme(sessionuuid, walletuuid, schemeuuid, address);
	}	
	
	async getCardCreditBalance(sessionuuid, walletuuid, carduuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getCreditBalance(sessionuuid, walletuuid, carduuid);
	}

	async topUpCard(sessionuuid, walletuuid, carduuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.topUpCard(sessionuuid, walletuuid, carduuid);
	}


	async _getRecommendedCardFeeLevel(session, wallet, card, tx_fee) {
		// standard fee level
		var	feelevel = {
			default_gas_limit_multiplier: 1,
			default_gas_price_multiplier: 1,
			avg_transaction_fee_multiplier: 1, 
			transaction_units_min_multiplier: 1
		};

		// get scheme transaction info
		var sessionuuid = session.getSessionUUID();
		var card_scheme = card.getScheme();
		var tx_info = await this.getSchemeTransactionInfo(sessionuuid, card_scheme.uuid, feelevel);

		var gasLimit = tx_info.gasLimit;
		var gasPrice = tx_info.gasPrice;
		var avg_transaction_fee = tx_info.avg_transaction_fee;

		var gas_unit = (card_scheme && card_scheme.network && card_scheme.network.ethnodeserver && card_scheme.network.ethnodeserver.gas_unit ? parseInt(card_scheme.network.ethnodeserver.gas_unit) : 21000);
		var credit_cost_unit_ratio = (avg_transaction_fee * 1000000000000000000) / (gas_unit * gasPrice);

		// execution cost
		var units_exec_fee; 
		var credits_exec_fee;
		
		if (tx_fee.estimated_cost_credits) {
			credits_exec_fee = tx_fee.estimated_cost_credits;
			units_exec_fee = await this._getUnitsFromCredits(session, card_scheme, credits_exec_fee);
		}
		else {
			units_exec_fee = (tx_fee.estimated_cost_units ? Math.ceil(tx_fee.estimated_cost_units / credit_cost_unit_ratio) : 1);
			credits_exec_fee = await card_scheme.getTransactionCreditsAsync(units_exec_fee);
		}

		// max price
		var credits_max_fee = gasLimit * gasPrice;
		var units_max_fee =  await this._getUnitsFromCredits(session, card_scheme, credits_max_fee);

		if (units_exec_fee > units_max_fee)
			feelevel.default_gas_limit_multiplier = Math.ceil(units_exec_fee / units_max_fee);

		return feelevel;
	}

	async getRecommendedCardFeeLevel(sessionuuid, walletuuid, carduuid, tx_fee) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var card = await wallet.getCardFromUUID(carduuid);

		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		return this._getRecommendedCardFeeLevel(session, wallet, card, tx_fee);
	}

	async computeCardTransactionFee(sessionuuid, walletuuid, carduuid, tx_fee, feelevel = null) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var card = await wallet.getCardFromUUID(carduuid);

		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		// get scheme transaction info
		var card_scheme = card.getScheme();
		var tx_info = await this.getSchemeTransactionInfo(sessionuuid, card_scheme.uuid, feelevel);

		var gasLimit = tx_info.gasLimit;
		var gasPrice = tx_info.gasPrice;
		var avg_transaction_fee = tx_info.avg_transaction_fee;

		var gas_unit = (card_scheme && card_scheme.network && card_scheme.network.ethnodeserver && card_scheme.network.ethnodeserver.gas_unit ? parseInt(card_scheme.network.ethnodeserver.gas_unit) : 21000);
		var credit_cost_unit_ratio = (avg_transaction_fee * gasPrice) / gas_unit;

		// execution cost
		var units_exec_fee; 
		var credits_exec_fee;
		
		if (tx_fee.estimated_cost_credits) {
			credits_exec_fee = tx_fee.estimated_cost_credits;
			units_exec_fee = await this._getUnitsFromCredits(session, card_scheme, credits_exec_fee);
		}
		else {
			units_exec_fee = (tx_fee.estimated_cost_units ? Math.ceil(tx_fee.estimated_cost_units / credit_cost_unit_ratio) : 1);
			credits_exec_fee = await card_scheme.getTransactionCreditsAsync(units_exec_fee);
		}

		// transferred value
		var units_transferred;
		var credits_transferred;

		if (tx_fee.transferred_credits) {
			credits_transferred = tx_fee.transferred_credits;
			units_transferred = await this._getUnitsFromCredits(session, card_scheme, credits_exec_fee);
		}
		else {
			units_transferred = tx_fee.transferred_credit_units;
			credits_transferred = await card_scheme.getTransactionCreditsAsync(units_transferred);
		}

		// max price
		var credits_max_fee = gasLimit * gasPrice;
		var units_max_fee =  await this._getUnitsFromCredits(session, card_scheme, credits_max_fee);

		// fill tx_fee
		tx_fee.tx_info = tx_info;

		tx_fee.estimated_fee = {};

		// estimated execution fee
		tx_fee.estimated_fee.execution_units = units_exec_fee; 
		tx_fee.estimated_fee.execution_credits = credits_exec_fee; 

		// estimated transaction total
		tx_fee.estimated_fee.total_credits = credits_exec_fee + credits_transferred; 
		tx_fee.estimated_fee.total_units = await this._getUnitsFromCredits(session, card_scheme, tx_fee.estimated_fee.total_credits); 

		// max fee
		tx_fee.estimated_fee.max_units = units_max_fee; 
		tx_fee.estimated_fee.max_credits = credits_max_fee; 

		// required balance
		if (tx_fee.estimated_fee.max_credits > tx_fee.estimated_fee.total_credits) {
			tx_fee.required_credits = tx_fee.estimated_fee.max_credits;
		}
		else {
			if (tx_fee.estimated_fee.max_credits >= tx_fee.estimated_fee.execution_credits)
				tx_fee.required_credits = tx_fee.estimated_fee.max_credits + credits_transferred; // because of "Insufficient funds for gas * price + value" web3 error
			else {
				tx_fee.required_credits = tx_fee.estimated_fee.total_credits; // won't go through because will reach gas limit
				tx_fee.limit_overdraft = true;
			}
		}
		
		tx_fee.required_units =  await this._getUnitsFromCredits(session, card_scheme, tx_fee.required_credits); 

		return tx_fee;
	}


	async canCompleteCardTransaction(sessionuuid, walletuuid, carduuid, tx_fee, feelevel = null) {
		// get card balance
		const credits = await this.getCardCreditBalance(sessionuuid, walletuuid, carduuid);

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
	
		var card = await wallet.getCardFromUUID(carduuid);

		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		// can the card send transactions
		var cardaccount = card._getSessionAccountObject();

		if (!cardaccount)
			return false;

		var privatekey = cardaccount.getPrivateKey();
	
		if (!privatekey)
			return false;



		// get transaction fee
		var tx_fee = await this.computeCardTransactionFee(sessionuuid, walletuuid, carduuid, tx_fee, feelevel);

		// check estimated cost is not above max credits (corresponds to tx_fee.limit_overdraft == true)
		if (tx_fee.estimated_fee.execution_credits > tx_fee.estimated_fee.max_credits) {
			return false;
		}

		// check balance in units is above requirement
		if (credits.transactionunits < tx_fee.required_units) {
			return false;
		}

		// check
		var tx_info = tx_fee.tx_info;
		var scheme_units_threshold = tx_info.units_threshold;
		var scheme_credits_threshold = tx_info.credits_threshold;

		if (scheme_credits_threshold > credits.transactioncredits) {
			if (tx_fee.threshold_enforced === true) {
				tx_fee.required_units = scheme_credits_threshold;
				return false;
			}
			else {
				tx_fee.threshold_unmet = true;
			}
		}


		return true;
	}

	async createCardERC20Token(sessionuuid, walletuuid, carduuid, erc20token, feelevel = null) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var card = await wallet.getCardFromUUID(carduuid);

		if (!card)
			return Promise.reject('could not find card ' + carduuid);
	

		if (card.isLocked()) {
			await card.unlock();
		}

		var erc20tokenobject = await card.deployToken(erc20token.name, erc20token.symbol, erc20token.totalsupply, erc20token.decimals);

		if (!erc20tokenobject)
			return Promise.reject('could not create token');

		var tokenaddress = erc20tokenobject.getAddress();
		var tokenuuid = erc20tokenobject.getTokenUUID();

		var result = {uuid: tokenuuid, address: tokenaddress};

		return result;
	}

	//
	// Currency functions
	//
	async readLocalCurrencies(sessionuuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.readLocalCurrencies(sessionuuid);
	}

	async saveLocalCurrencies(sessionuuid, currencies) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.saveLocalCurrencies(sessionuuid, currencies);
	}

	async saveLocalCurrency(sessionuuid, currency) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.saveLocalCurrency(sessionuuid, currency);
	}

	async getCurrencies(sessionuuid, walletuuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.getCurrencies(sessionuuid, walletuuid);
	}

	async getCurrencyFromUUID(sessionuuid, currencyuuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.getCurrencyFromUUID(sessionuuid, currencyuuid);
	}

	// TODO: replace with mvccurrencies.synchronizeCurrency for version >= 0.30.9
	async synchronizeCurrency(sessionuuid, walletuuid, currency) {
		// to fetch name, symbol,... if it went bad during the first import
		if (!currency)
			return Promise.reject('currency is undefined');
		
		if (!currency.address)
			return Promise.reject('currency has not token address');


		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var currenciesmodule = global.getModuleObject('currencies');

		var currencyscheme = await currenciesmodule.getCurrencyScheme(session, currency);
	
		if (!currencyscheme)
			return Promise.reject('could not find scheme of currency ' + currency.uuid);
		
		var childsession = await this._getMonitoredSchemeSession(session, wallet, currencyscheme);

		// get erc20 token contract
		var erc20token_contract = await _apicontrollers.importERC20Token(childsession, currency.address);

		// re-fetch main elements
		currency.name = await erc20token_contract.getChainName();
		currency.symbol = await erc20token_contract.getChainSymbol();
		currency.decimals = await erc20token_contract.getChainDecimals();

		// then save currency
		await currenciesmodule.saveLocalCurrency(session, currency);

		return currency;
	}

	// TODO: replace with mvccurrencies.setCurrencyDescription for version >= 0.30.9
	async setCurrencyDescription(sessionuuid, walletuuid, currencyuuid, description) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);

		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);


		var currenciesmodule = global.getModuleObject('currencies');

		// set description
		currency.description = description;
		
		// then save currency
		await currenciesmodule.saveLocalCurrency(session, currency);

		return currency;
	}


	// TODO: replace with mvccurrencies.getCurrenciesFromAddress for version >= 0.30.9
	async getCurrenciesFromAddress(sessionuuid, walletuuid, schemeuuid, address) {
		var currencies = await this.getCurrencies(sessionuuid, walletuuid);

		var arr = [];
		var tokenaddress = (address ? address.trim().toLowerCase() : null);

		for (var i = 0; i < (currencies ? currencies.length : 0); i++) {
			let _currencyaddress = (currencies[i].address ? currencies[i].address.trim().toLowerCase() : null);
			if ((currencies[i].scheme_uuid == schemeuuid) && (_currencyaddress == tokenaddress))
			arr.push(currencies[i]);
		}

		return arr;
	}

	async createCurrencyCard(sessionuuid, walletuuid, currencyuuid, privatekey) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.createCurrencyCard(sessionuuid, walletuuid, currencyuuid, privatekey);
	}

	// TODO: remove for version >= 0.30.8
/* 	async _getCurrencyCardList(session, wallet, currency) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies._getCurrencyCardList(session, wallet, currency);
	} */

	async makeCurrencyCard(sessionuuid, walletuuid, currencyuuid, carduuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.makeCurrencyCard(sessionuuid, walletuuid, currencyuuid, carduuid);
	}


	async getCurrencyCard(sessionuuid, walletuuid, currencyuuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.getCurrencyCard(sessionuuid, walletuuid, currencyuuid);
	}

	async setCurrencyCard(sessionuuid, walletuuid, currencyuuid, carduuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.setCurrencyCard(sessionuuid, walletuuid, currencyuuid, carduuid);
	}

	// TODO: replace with mvccurrencies.getCurrencyAmount WHEN IT IS FIXED
	async getCurrencyAmount(sessionuuid, currencyuuid, amount) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);

		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		return mvccurrencies._createCurrencyAmount(session, currency, amount);
		// TODO: fix getCurrencyAmount
		// return mvccurrencies.getCurrencyAmount(sessionuuid, currencyuuid, amount);
	}

	async _getCurrencyAmountAlt(sessionuuid, currencyuuid, amount) {
		// used by construct-token-amount.js while mvccurrencies.getCurrencyAmount not FIXED
		// for my-widget
		var global = this.global;
		
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		return mvccurrencies.getCurrencyAmount(sessionuuid, currencyuuid, amount);
	}

	
	async getCurrencyPosition(sessionuuid, walletuuid, currencyuuid, carduuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.getCurrencyPosition(sessionuuid, walletuuid, currencyuuid, carduuid);
	}
	
	async _createDecimalAmount(session, amount, decimals) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		return _apicontrollers.createDecimalAmount(session, amount, decimals);
	}
	
	async payAmount(sessionuuid, walletuuid, carduuid, toaddress, currencyuuid, amount, feelevel = null) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.payAmount(sessionuuid, walletuuid, carduuid, toaddress, currencyuuid, amount, feelevel);
	}

	async getCurrencyTotalSupply(sessionuuid, walletuuid, currencyuuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.getCurrencyTotalSupply(sessionuuid, walletuuid, currencyuuid);
	}

	async importCurrencyFromTokenUUID(sessionuuid, walletuuid, carduuid, tokenuuid) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.importCurrencyFromTokenUUID(sessionuuid, walletuuid, carduuid, tokenuuid);
	}

	async importCurrencyFromTokenAddress(sessionuuid, walletuuid, carduuid, tokenaddress, options) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.importCurrencyFromTokenAddress(sessionuuid, walletuuid, carduuid, tokenaddress, options);
		// note: mvccurrencies.importCurrencyFromTokenAddress does not have an options parameter
	}

	//
	// utils
	//

	async formatCurrencyAmount(sessionuuid, currencyuuid, currencyamount, options) {
		var global = this.global;
		var mvccurrencies = global.getModuleObject('mvc-currencies');
		return mvccurrencies.formatCurrencyAmount(sessionuuid, currencyuuid, currencyamount, options);
	}

	formatAmount(amount, decimals) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.formatAmount(amount, decimals);
	}
	
	formatTokenAmount(amount, token, options) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.formatTokenAmount(amount, token, options);
	}


	formatDate(unixdate, format) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.formatDate(unixdate, format);
	}
	
	fitString(str, maxlength) {
		if (!str)
			return str; // to avoid returning undefined for ''
			
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.fitString(str, maxlength);
	}


	//
	// static
	//
	static getObject() {
		return module_instance;
	}
}

module_instance = new Module();


if ( (typeof GlobalClass === 'undefined') || (!GlobalClass)) {
	var GlobalClass = ((typeof window !== 'undefined') && window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}

if ( typeof GlobalClass !== 'undefined' && GlobalClass ) {
	GlobalClass.getGlobalObject().registerModuleObject(module_instance);

	//dependencies
	GlobalClass.getGlobalObject().registerModuleDepency('mvc-mywidget', 'common');
	GlobalClass.getGlobalObject().registerModuleDepency('mvc-mywidget', 'mvc');

	// module classes	
}


export default Module;